export const DEAL_DELAY = 0.0285;
export const CARD_DEAL_MOVE_TIME = 0.1;
export const CARD_MOVE_TIME = 0.35; // normal card move
export const FLIP_CARD_TIME = 0.15; // normal card move
export const STOCK_PILE_FLIP_TIME = 0.11; // normal card move
export const CARD_GROUP_DELAY_TIME = 0.05; // normal card move
export const AUTOCOMPLETE_MOVE_TIME = 0.15;
export const STOCK_PILE_UNDO_DURATION = 0.08;
export const CARD_SHAKE_DURATION = 300;
export const AUTOCOMPLETE_TRIGGER_DELAY = 60;
export const AUTOPLAY_DELAY = 180;
export const WIN_POPUP_DELAY = 700;
export const WIN_POPUP_SPIDER_DELAY = 1300;

export const MENU_TRANSITION_TIME = 0.36;

export const CARD_HINT_MOVE_TIME = 0.8; // normal card move
